<template>
  <el-dialog :close-on-click-modal="false" title="订单状态" :visible.sync="isShow" width="40%">
    <el-table :data="orderStatusLogs">
      <el-table-column label="状态">
        <template v-slot="scope">
          <span class="change-color">{{$config.orderStatus[scope.row.orderStatus]||scope.row.orderStatus}}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="dateCreated">
      </el-table-column>
      <el-table-column label="操作人" prop="userCreated">
      </el-table-column>
      <el-table-column label="操作人姓名" prop="createdFullName">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
 <script>
import { getOrderStatusLogs } from '@/api/oms'
export default {
  name: 'orderstatus-dialog',
  data () {
    return {
      isShow: false,
      orderId: '',
      orderStatusLogs: []
    }
  },
  methods: {
    show (orderId) {
      this.isShow = true
      this.orderId = orderId
      this.getOrderStatusLogs()
    },
    hide () {
      this.isShow = false
    },
    getOrderStatusLogs () {
      getOrderStatusLogs(this.orderId).then(res => {
        this.orderStatusLogs = res.data.data
      })
    }
  }
}
</script>
 <style scoped lang="less">
.orderstatus-dialog {
  position: fixed;
  width: 100%;
  top: 20%;
  .order-cn {
    background: #fff;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
    width: 713px;
    height: 424px;
    border-radius: 8px;
    margin: 0 auto;
    padding: 22px 60px;
    box-sizing: border-box;
    i {
      float: right;
      font-size: 28px;
      overflow: hidden;
      height: 28px;
      cursor: pointer;
      color: #2a2a2a;
    }
    h3 {
      font-size: 24px;
      line-height: 40px;
      padding: 20px 0;
      color: #2a2a2a;
      margin-top: 15px;
      border-bottom: 1px solid #e8e8e8;
      font-weight: normal;
    }
    p {
      font-size: 18px;
      color: #2a2a2a;
      line-height: 30px;
      padding: 10px 0;
    }
    button {
      width: 110px;
      height: 46px;
      border-radius: 30px;
      color: #fff;
      font-size: 18px;
      background: #2a2a2a;
      outline: none;
      border: none;
      box-shadow: none;
      float: right;
      margin-top: 150px;
      cursor: pointer;
      margin-left: 15px;
      &:hover {
        opacity: 0.6;
      }
    }
    .cancel {
      background: #707070;
    }
    table {
      text-align: center;
      font-size: 16px;
      color: #1d1e1d;
      border-color: #e8e8e8;
      margin-top: 8px;
      max-height: 300px;
      tr {
        th {
          line-height: 50px;
          background: #f2f2f2;
          font-weight: normal;
        }
        td {
          line-height: 80px;
          color: #1d1e1d;
          font-weight: 100;
        }
      }
    }
  }
}
</style>
